import classnames from 'classnames';
import { FillTag } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * CategoryItemコンポーネントに渡されるプロパティを定義するインターフェース
 */
interface Props {
  /** カテゴリのタイトル */
  title: string;
  /** カテゴリが選択されているかどうか（オプション） */
  selected?: boolean;
  /** 求人数 */
  numberOfJobs: number;
  /** クリック時のイベントハンドラー */
  onClick: () => void;
  /** カテゴリがチェックされているかどうか（オプション） */
  checked?: boolean;
}

/**
 * CategoryItemは求人カテゴリを表示するコンポーネント
 *
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} - カテゴリアイテムの要素
 */
export const CategoryItem: React.FC<Props> = ({
  title,
  selected = false,
  numberOfJobs,
  onClick,
  checked = false,
}) => {
  return (
    <li
      className={classnames(styles.industryCategoryItem, {
        [styles['industryCategoryItem--selected']]: selected,
      })}
    >
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className={styles.industryCategoryItem__link}
      >
        <div>
          <span
            className={classnames(styles.industryCategoryItem__title, {
              [styles['industryCategoryItem__title--selected']]: selected,
            })}
          >
            {title}
          </span>
          <span className={styles.industryCategoryItem__numberOfJobs}>
            {`(${numberOfJobs.toLocaleString()})`}
          </span>
        </div>
        {checked && (
          <FillTag
            color="lightGreen"
            className={styles.industryCategoryItem__checkedTag}
          >
            選択中
          </FillTag>
        )}
      </a>
    </li>
  );
};
